import { catchError } from 'rxjs/operators';
import { EMPTY, Observable } from 'rxjs';
import { ErrorHandlerService } from 'src/app/app-services-async/w-h-error-handler.service';

export function handleGlobalError<T>(options?: { onError?: () => void }) {
  return (source: Observable<T>) =>
    source.pipe(
      catchError((err) => {
        ErrorHandlerService.handleGlobalError(err);
        options?.onError?.();
        return EMPTY;
      }),
    );
}
